import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import type { FieldFormProps } from '@helpcenter/field-types';
import { FieldBase } from 'view/common/fields/field-base';
import { Checkbox } from '@atlaskit/checkbox';

export interface Item {
	label: string;
	value: string;
}
export interface Props extends FieldFormProps<string[]> {
	items: Item[];
	defaultValue?: string[];
}

export default class CustomCheckboxGroup extends React.PureComponent<Props> {
	checkedValues: string[];

	constructor(props: Props) {
		super(props);
		this.checkedValues = props.defaultValue || [];
	}

	onChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
		if (this.props.onChange) {
			const currentValue = e.currentTarget.value as string;

			if (this.checkedValues.includes(currentValue)) {
				this.checkedValues = this.checkedValues.filter((value) => value !== currentValue);
			} else {
				this.checkedValues.push(currentValue);
			}

			this.props.onChange(this.props.id, [...this.checkedValues]);
		}
	};
	render() {
		const { label, required, description, id, items, errorMessage, disabled } = this.props;

		return (
			<FieldBase
				htmlFor={id}
				labelId={id}
				label={label}
				required={required}
				description={description}
				errorMessage={errorMessage}
			>
				<CheckboxGroup
					role="group"
					aria-labelledby={id}
					aria-describedby={`${id}-field-description`}
				>
					{items.map((item) => (
						<Checkbox
							isDisabled={disabled}
							key={item.label}
							name={item.label}
							label={item.label}
							value={item.value}
							defaultChecked={this.checkedValues.includes(item.value)}
							onChange={this.onChange}
						/>
					))}
				</CheckboxGroup>
			</FieldBase>
		);
	}
}

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const CheckboxGroup = styled.div`
	display: flex;
	flex-direction: column;
`;
